(function($) {

    // Show cookies bar if cookies is not set yet
    if(!getCookie("cookieConsent")){
        $(".cookie__main").addClass("cookie-display");
    }

    function cookieShowSettings(){
        $(".cookie__main").removeClass("cookie-display");
        $(".cookie__detail").addClass("cookie-display");
    }

    function cookieHideSettings(){
        $(".cookie__main").addClass("cookie-display");
        $(".cookie__detail").removeClass("cookie-display");
    }

    function cookieSetHide(){
        $(".cookie__main").removeClass("cookie-display");
        $(".cookie__detail").removeClass("cookie-display");
        $("body").removeClass("cookie-set");
    }

    $(".cookie-show, .cookie-settings, .cookie-show-js").on("click", function () {
        $("body").addClass("cookie-set");
        cookieShowSettings();
    })

    $(".cookie__detail-close").on("click", function () {
        $("body").removeClass("cookie-set");
        cookieHideSettings();
    })

    $(".cookie-set").on("click", function () {
        cookieSetHide();
    })

    function pixel_maybe_send_cookie_consent(ads_val, analytics_val){
        if (typeof gp_pixel !== "undefined" && gp_pixel.enabled){
            let consent = "revoke";
            if (ads_val === "granted" && analytics_val === "granted"){
                consent = "grant";
            }

            fbq('consent', consent);
        }
    }

    function send_cookie_consent_data(ads_val, analytics_val, personalization_val){

        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}


        gtag('consent', 'update', {
            'ad_storage': ads_val,
            'ad_personalization': ads_val,
            'ad_user_data': ads_val,
            'analytics_storage': analytics_val,
            'personalization_storage': personalization_val,
        });

        // Grant / revoke Pixel cookie consent
        pixel_maybe_send_cookie_consent(ads_val, analytics_val);

        // Send GTM update event
        dataLayer.push({'event': 'cookie_consent_update'});

        let data = {
            'action': 'update_cookie_consent',
            'ad_storage': ads_val,
            'analytics_storage': analytics_val,
            'personalization_storage': personalization_val,
        }

        gp_ajax({
            url: ghostpress_params.ajax_url,
            type: "post",
            dataType: "json",
            data: data
        })

        // $.post(ghostpress_params.ajax_url, data);

        cookieSetHide();
    }

    // Returns cookies value by name
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /* Update cookie preferences when cookies form is submitted */
    // Accept all from cookies bar
    $('#cookie-accept').on('click', function (e){
        e.preventDefault();

        send_cookie_consent_data("granted", "granted", "granted");
    });

    // Disable all in settings
    $('#cookie__consent_disable-all').on('click', function (e) {
        e.preventDefault();

        send_cookie_consent_data("denied", "denied", "denied");

        $('#cookie').find('.cookie__detail-checkbox:not(.cookie__detail-checkbox-disabled) input[type="checkbox"]:checked').removeAttr('checked');
    });

    // Allow selected in settings
    $('#cookie__consent_allow-all').on('click', function (e) {
        e.preventDefault();

        function gtag_consent_value(elem){
            if (elem.is(":checked")){
                return "granted";
            }
            else {
                return "denied";
            }
        }

        let ads_val = gtag_consent_value($('input#cookie_consent_marketing'));
        let analytics_val = gtag_consent_value($('input#cookie_consent_analytics'));
        let personalization_val = gtag_consent_value($('input#cookie_consent_personalization'));

        send_cookie_consent_data(ads_val, analytics_val, personalization_val);

    });

    // Enable all in settings
    $('#cookie_consent_form').on('submit', function (e){
        e.preventDefault();

        send_cookie_consent_data("granted", "granted", "granted");
        $('#cookie').find('.cookie__detail-checkbox:not(.cookie__detail-checkbox-disabled) input[type="checkbox"]').prop('checked', true);

    });

})(jQuery);
